export default async function basicFetch_blob(url, options) {

  return await fetch(url, options)
    .then(async (response) => {
      return await response.blob()
      .then((body) => {

        if(response.status === 200) {
          return body
        }
        else {
          throw new Error("failed - " + url)
        }
      })
    })
    .catch(err => {
      console.error('API ERROR', err)
      throw err
    })
}